export const ALERT_SET_ITEMS = '@alert.set.items';
